"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchOverlay = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var blur_1 = require("@hiyllo/ux/blur");
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var react_native_1 = require("react-native");
var escape_hatch_1 = require("@hiyllo/ux/escape-hatch");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var platform_1 = require("@hiyllo/ux/platform");
var loading_spinner_1 = require("@hiyllo/ux/loading-spinner");
var styled_1 = require("@hiyllo/ux/styled");
var modal_1 = require("@hiyllo/ux/modal");
var keyboard_hint_1 = require("./components/keyboard-hint"); // Native Ready
var contexts_1 = require("./contexts");
var search_result_1 = require("./components/search-results/search-result");
var custom_entry_1 = require("./components/search-results/custom-entry");
var theme_1 = require("@hiyllo/ux/theme");
var use_search_1 = require("../../hooks/use-search");
var determine_message_from_filter_1 = require("../../lib/determine-message-from-filter");
var SearchResultsPlaceholder = (0, styled_1.styledRN)(react_native_1.Text, {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 50
});
var SearchResultsContainer = (0, styled_1.styledRN)(react_native_1.View, {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingTop: 10
});
var SearchOverlayContainer = (0, styled_1.styledRN)(react_native_1.Pressable, function (_a) {
    var isMobile = _a.isMobile;
    return ({
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isMobile ? 'flex-start' : 'center',
        alignItems: 'center'
    });
});
var SearchMainContentContainer = (0, styled_1.styledRN)(react_native_1.Pressable, {
    padding: 30,
    width: '100%',
    maxWidth: 750,
    height: '100%'
});
var SearchInputNative = (0, styled_1.styledRN)(react_native_1.TextInput, function (_a) {
    var $theme = _a.$theme;
    return (__assign(__assign({}, (react_native_1.Platform.OS === 'web'
        ? {
            border: 'none',
            outline: 'none'
        }
        : {})), { display: 'flex', color: $theme.foreground, height: 50, width: 0, flexGrow: 1, padding: 0, margin: 0, backgroundColor: 'transparent' }));
});
var SearchInputWeb = (0, styled_1.styled)('input', function (_a) {
    var $theme = _a.$theme;
    return (__assign(__assign({}, (react_native_1.Platform.OS === 'web'
        ? {
            border: 'none',
            outline: 'none'
        }
        : {})), { display: 'flex', color: $theme.foreground, height: 50, width: 0, flexGrow: 1, padding: 0, margin: 0, backgroundColor: 'transparent' }));
});
var SearchInputContainer = (0, styled_1.styledRN)(react_native_1.View, function (_a) {
    var $theme = _a.$theme;
    return ({
        backgroundColor: '#282828bb',
        backdropFilter: 'blur(50px)',
        color: $theme.foreground,
        borderRadius: 30,
        paddingLeft: 20,
        paddingRight: 20,
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10
    });
});
var AboveBarMessage = (0, styled_1.styledRN)(react_native_1.Text, {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: '#ccc',
    gap: 2.5
});
var AboveBarRow = (0, styled_1.styledRN)(react_native_1.Pressable, {
    paddingBottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    zIndex: 10
});
var PaddingRight5 = (0, styled_1.styledRN)(react_native_1.Text, {
    paddingRight: 5
});
var LabelComponent = react_1["default"].memo(function LabelComponent(props) {
    if (react_native_1.Platform.OS === 'web') {
        return (0, jsx_runtime_1.jsx)("label", { children: props.children });
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children });
});
var NativeWrapper = react_1["default"].memo(function NativeWrapper(props) {
    return ((0, jsx_runtime_1.jsx)(react_native_1.Modal, __assign({ visible: true, transparent: true }, { children: props.children })));
});
var WebWrapper = react_1["default"].memo(function WebWrapper(props) {
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, __assign({ onClose: props.onClose }, { children: props.children })));
});
exports.SearchOverlay = react_1["default"].memo(function SearchOverlay(props) {
    var _a, _b, _c, _d;
    var inputRef = react_1["default"].useRef(null);
    var _e = react_1["default"].useState(''), query = _e[0], setQuery = _e[1];
    var self = (0, omni_continuity_1.useSelf)();
    var _f = (0, use_search_1.useSearch)({
        self: self,
        filterType: props.filterType,
        filterChatUUID: props.filterChatUUID,
        dontIncludeSelf: props.dontIncludeSelf,
        tagFilter: props.tagFilter
    }), data = _f.data, _onChange = _f.onChange, overrideResults = _f.overrideResults, loading = _f.loading, showWarmingUp = _f.showWarmingUp;
    var onChange = react_1["default"].useCallback(function (value) {
        var query = value.trim();
        setQuery(query);
        _onChange(query);
    }, [_onChange]);
    react_1["default"].useEffect(function () {
        if (inputRef.current) {
            if (react_native_1.Platform.OS === 'web') {
                inputRef.current.focus();
            }
        }
    }, []);
    (0, escape_hatch_1.useEscapeHatch)(props.onClose);
    react_1["default"].useEffect(function () {
        if (react_native_1.Platform.OS === 'web') {
            var onKeyDown_1 = function (evt) {
                if (evt.key === 'Enter') {
                    inputRef.current.focus();
                }
            };
            window.addEventListener('keydown', onKeyDown_1);
            return function () {
                window.removeEventListener('keydown', onKeyDown_1);
            };
        }
    }, [props]);
    var _g = react_1["default"].useState(false), focused = _g[0], setFocused = _g[1];
    var showCustomEntry = react_1["default"].useMemo(function () {
        var _a;
        return (_a = props.acceptCustomInput) === null || _a === void 0 ? void 0 : _a.call(props, query);
    }, [props, query]);
    var FontAwesomeIcon = (0, platform_1.useFontAwesomeIcon)();
    var isMobile = react_native_1.Platform.OS === 'web' ? window.innerHeight > window.innerWidth : true;
    var $theme = (0, theme_1.useTheme)();
    console.log('... search overlay render');
    var Wrapper = react_native_1.Platform.OS === "web" ? WebWrapper : NativeWrapper;
    return ((0, jsx_runtime_1.jsx)(Wrapper, __assign({ onClose: props.onClose }, { children: (0, jsx_runtime_1.jsx)(contexts_1.InputFocusedContext.Provider, __assign({ value: focused }, { children: (0, jsx_runtime_1.jsxs)(SearchOverlayContainer, __assign({ isMobile: isMobile, onPress: props.onClose }, { children: [(0, jsx_runtime_1.jsx)(blur_1.BlurView, { blurAmount: 8, style: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            zIndex: -1
                        } }), (0, jsx_runtime_1.jsx)(react_native_1.SafeAreaView, __assign({ style: { width: "100%", display: "flex", flexDirection: "column", alignItems: "center", height: "100%" } }, { children: (0, jsx_runtime_1.jsx)(SearchMainContentContainer, __assign({ onPress: function (evt) { return evt.stopPropagation(); } }, { children: (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, __assign({ style: { height: "100%" } }, { children: [(0, jsx_runtime_1.jsxs)(AboveBarRow, __assign({ onPress: props.onClose }, { children: [focused ? ((0, jsx_runtime_1.jsx)(AboveBarMessage, { children: (_a = props.overrideFocusLabel) !== null && _a !== void 0 ? _a : (0, determine_message_from_filter_1.determineMessageFromFilter)(props.filterType) })) : ((0, jsx_runtime_1.jsxs)(AboveBarMessage, { children: [(0, jsx_runtime_1.jsx)(PaddingRight5, { children: "Hit" }), (0, jsx_runtime_1.jsx)(keyboard_hint_1.SearchResultKeyboardHint, { value: "Enter" }), "to search..."] })), isMobile ? ((0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_light_svg_icons_1.faTimes, color: $theme.foreground })) : ((0, jsx_runtime_1.jsxs)(AboveBarMessage, { children: [(0, jsx_runtime_1.jsx)(keyboard_hint_1.SearchResultKeyboardHint, { value: "ESC" }), "to close"] }))] })), (0, jsx_runtime_1.jsx)(LabelComponent, { children: (0, jsx_runtime_1.jsxs)(SearchInputContainer, { children: [loading ? ((0, jsx_runtime_1.jsx)(loading_spinner_1.LoadingSpinner, {})) : ((0, jsx_runtime_1.jsx)(FontAwesomeIcon, { icon: pro_light_svg_icons_1.faSearch, color: $theme.foreground })), react_native_1.Platform.OS === 'web' ? ((0, jsx_runtime_1.jsx)(SearchInputWeb, { _ref: inputRef, placeholder: (_b = props.overridePlaceholderText) !== null && _b !== void 0 ? _b : 'What are you looking for...?', onChange: function (evt) {
                                                        onChange(evt.target.value);
                                                    }, onKeyDown: function (evt) {
                                                        if (evt.key === 'Escape' ||
                                                            evt.key === 'Enter' ||
                                                            (evt.altKey && evt.code.startsWith('Digit'))) {
                                                            setTimeout(function () {
                                                                window.dispatchEvent(evt.nativeEvent);
                                                            });
                                                            return;
                                                        }
                                                        evt.stopPropagation();
                                                        if (evt.key === 'Tab') {
                                                            evt.preventDefault();
                                                            evt.currentTarget.blur();
                                                        }
                                                    }, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, autoFocus: true })) : ((0, jsx_runtime_1.jsx)(SearchInputNative, { placeholder: (_c = props.overridePlaceholderText) !== null && _c !== void 0 ? _c : 'What are you looking for...?', onChangeText: onChange, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, autoFocus: true, placeholderTextColor: $theme.foregroundInactive }))] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { children: data == null ? (loading ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showWarmingUp ? ((0, jsx_runtime_1.jsx)(SearchResultsPlaceholder, { children: "Just a second! Your personalized search engine is warming up, future searches will be faster." })) : null })) : isMobile ? null : ((0, jsx_runtime_1.jsx)(SearchResultsPlaceholder, { children: (_d = props.overrideHintText) !== null && _d !== void 0 ? _d : 'Type something...' }))) : data.length > 0 || showCustomEntry ? ((0, jsx_runtime_1.jsxs)(SearchResultsContainer, { children: [showCustomEntry ? ((0, jsx_runtime_1.jsx)(custom_entry_1.CustomEntryResult, { onClick: function () {
                                                        var _a;
                                                        (_a = props.onSubmitCustomInput) === null || _a === void 0 ? void 0 : _a.call(props, query);
                                                    }, index: 0, text: query })) : null, props.stickyOptions != null
                                                    ? props.stickyOptions.map(function (sr, i) { return ((0, jsx_runtime_1.jsx)(custom_entry_1.CustomEntryResult, { onClick: sr.onSelect, index: i + (showCustomEntry ? 1 : 0), text: sr.label }, i)); })
                                                    : null, data.slice(0, isMobile ? 5 : 100).map(function (sr, i) {
                                                    var _a, _b;
                                                    return ((0, jsx_runtime_1.jsx)(search_result_1.SearchResult, { index: i +
                                                            (showCustomEntry ? 1 : 0) +
                                                            ((_b = (_a = props.stickyOptions) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0), result: sr, onClose: props.onClose, onUpdateResults: overrideResults, overrideOnClick: props.onSelectResult }, sr.type + i.toString()));
                                                })] })) : ((0, jsx_runtime_1.jsx)(SearchResultsPlaceholder, { children: "No Results" })) })] })) })) }))] })) })) })));
});
